import { AvvirEvent } from "type_aliases";
import { ApiUserPermission } from "avvir";

export type UserPermissionsByIdLoadedEvent = AvvirEvent<typeof USER_PERMISSIONS_BY_ID_LOADED, { permissions: ApiUserPermission[] }>

const userPermissionsByIdLoaded = (permissions: ApiUserPermission[]): UserPermissionsByIdLoadedEvent => ({
  type: USER_PERMISSIONS_BY_ID_LOADED,
  payload: {
    permissions
  }
});

export const USER_PERMISSIONS_BY_ID_LOADED = "user_permissions_by_id_loaded";

export default userPermissionsByIdLoaded;
